// extracted by mini-css-extract-plugin
module.exports = {"textField":"TextField_textField__1d1rb","text":"TextField_text__3PPr5","alightRight":"TextField_alightRight__3SizT"};